import React, { FC, useState } from 'react'
import { useStoreState } from '@mortgage-pos/ui/store'
import { environment } from '@mortgage-pos/ui/env'
import { redirectTo } from '@mortgage-pos/utils'
import Button, { ButtonVariants } from '@mortgage-pos/ui/components/Button'
import SuccessIcon from '@mortgage-pos/ui/assets/success-icon.png'
import SuccessCard from '@mortgage-pos/ui/components/SuccessCard'

interface AUSResultsProps {
  modifierClass?: string
}

const AUSResults: FC<AUSResultsProps> = ({ modifierClass }) => {
  const { applicationGuid } = useStoreState((state) => state.application)
  const { mergedAnswers } = useStoreState((state) => state.answers)
  const [reportSuccess, setReportSuccess] = useState(false)

  const handleBorrowerPortalClick = () => {
    redirectTo(environment.borrowerPortal.uiBaseUrl)
  }

  // Construct name for personalized greeting
  const { firstName, lastName, hasCoBorrower, coBorrowerPersonalInfo } =
    mergedAnswers
  const coBorrower = coBorrowerPersonalInfo?.[0]

  let fullName = `${firstName} ${lastName}`
  if (hasCoBorrower === 'Yes' && coBorrower) {
    fullName += ` & ${coBorrower.firstName} ${coBorrower.lastName}`
  }

  return (
    <div className="app-content__wrap success-screen">
      <img className="success-screen__img" src={SuccessIcon} alt="success" />
      {reportSuccess ? (
        <>
          <hgroup>
            <h1 className="page__title success-screen__title">
              Congratulations, {fullName}!
            </h1>
            <h2 className="page__subtitle success-screen__subtitle">
              You've been pre-approved by Desktop Underwriter
            </h2>
          </hgroup>
          <p className="success-screen__content">
            Great news! Fannie Mae's Desktop Underwriter has pre-approved your
            loan application. This is a significant step toward your home
            purchase. Your loan officer will be reaching out to discuss the next
            steps in your homebuying journey and to answer any questions you may
            have.
          </p>
        </>
      ) : (
        <>
          <hgroup>
            <h1 className="page__title success-screen__title">
              Thank you for your application, {fullName}
            </h1>
            <h2 className="page__subtitle success-screen__subtitle">
              Your application needs additional review
            </h2>
          </hgroup>
          <p className="success-screen__content">
            While we couldn't automatically pre-approve your loan through
            Desktop Underwriter, you may still be eligible with additional
            documentation. This is common and not a rejection. Your loan officer
            will be contacting you shortly to discuss what additional
            information is needed and guide you through the next steps in the
            process.
          </p>
        </>
      )}

      <SuccessCard productName={environment?.productName} />

      <div className="success-screen__continue-container">
        <Button
          variant={ButtonVariants.next}
          content="Go to Borrower Portal"
          className="property-value-modal__lock-button"
          onClick={handleBorrowerPortalClick}
        />
      </div>
    </div>
  )
}

export default AUSResults
